import React from "react";

const UpdateContractor = () => {
  return <div>UpdateContractor</div>;
};

export default UpdateContractor;
